import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'
import settings from 'settings'
import { withRouter } from 'react-router-dom'
import io from 'socket.io-client'
import UIkit from 'uikit'
import moment from 'moment'
// import ace from 'brace'

// Components
import LessonSteps from 'app/views/components/LessonSteps'
import Icon from 'app/views/components/Icon'
import ProxyBar from 'app/views/components/ProxyBar'
import Browser from 'app/views/components/Browser'
import LessonSidebar from 'app/views/components/LessonSidebar'

// Components
import CodeEditor from 'app/views/components/CodeEditor'
import CodeOutput from 'app/views/components/CodeOutput'
import PatchHistory from 'app/views/components/PatchHistory'
import ProxyEditor from 'app/views/components/ProxyEditor'
import ProxyHistory from 'app/views/components/ProxyHistory'
import ScratchpadButton from 'app/views/components/ScratchpadButton'


// Redux
import { getCodeSubmissions } from 'app/state/modules/hacker'
import { resetLinter } from 'app/state/modules/linter'
import {
  sandboxSetPath,
  setIntercept,
  setStatus,
  setUrl,
  sandboxInit,
  sandboxReset,
  onRequest,
  onResponse,
  getPendingRequest,
  addEditedRequest,
} from 'app/state/modules/proxy'

import {
  replOnError,
  replOnViewError,
  replSetCode,
  replSetEngine,
  replSetEngines,
  replSetOutput,
  replSetDefaultEngine,
  replSetLocalCode,
  setReplIsPullingCode,
  setFirstTimePull,
} from 'app/state/modules/repl'

import {
  pingContent,
} from 'app/state/modules/content'

// Utils
import analytics from 'app/views/utils/analytics'
import { cleanObjectRequest } from 'app/views/utils/proxy'
import GenericModal from 'app/views/components/Modals/GenericModal'

const propTypes = {
  baseUrl: PropTypes.string.isRequired,
  proxyStatus: PropTypes.oneOf([
    'loading',
    'reset',
    'init',
    'error',
    'listening',
    'disabled',
    'waiting',
  ]).isRequired,
  intercept: PropTypes.bool.isRequired,
  requests: PropTypes.array.isRequired,
  requestCount: PropTypes.number.isRequired,
  pendingRequest: PropTypes.object,
  onSandboxReset: PropTypes.func.isRequired,
  onSetStatus: PropTypes.func.isRequired,
  onSetIntercept: PropTypes.func.isRequired,
  onRequest: PropTypes.func.isRequired,
  onResponse: PropTypes.func.isRequired,
  onReplSetOutput: PropTypes.func.isRequired,
  onReplOnError: PropTypes.func.isRequired,
  onReplOnViewError: PropTypes.func.isRequired,
  onReplSetCode: PropTypes.func.isRequired,
  onReplSetEngine: PropTypes.func.isRequired,
  onReplSetEngines: PropTypes.func.isRequired,
}

const defaultProps = {
  pendingRequest: null,
}

class BrowserSkillArea extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      forceNew: false,
      pending_url: '',
      compiling: false,
      popoutMode: false,
    }
    this.forceNewCount = 0
    this.socket = null

    this.popoutWindow = null
    this.reapPopoutWindowTimer = null

    this.handleSandboxReset = this.handleSandboxReset.bind(this)
    this.initializeSandbox = this.initializeSandbox.bind(this)
    this.handleOnInitAck = this.handleOnInitAck.bind(this)
    this.toggleIntercept = this.toggleIntercept.bind(this)

    // tabs
    this.handleClickProxyTab = this.handleClickProxyTab.bind(this)
    this.handleClickHistoryTab = this.handleClickHistoryTab.bind(this)
    this.handleClickCodeTab = this.handleClickCodeTab.bind(this)
    this.handleClickCodeOutputTab = this.handleClickCodeOutputTab.bind(this)
    this.handleClickPatchHistoryTab = this.handleClickPatchHistoryTab.bind(this)
    this.handleOnRequest = this.handleOnRequest.bind(this)
    this.handleOnResume = this.handleOnResume.bind(this)
    this.handleOnResponse = this.handleOnResponse.bind(this)
    this.handleOnPatch = this.handleOnPatch.bind(this)
    this.handleOnPopoutMode = this.handleOnPopoutMode.bind(this)
    this.cleanSandBoxes = this.cleanSandBoxes.bind(this)
    this.isDemo = this.props.match.path.indexOf('/demo') > -1
  }

  componentDidMount() {
    this.cleanSandBoxes(() => {
      this.pingInterval = setInterval(() => {
        const localStorageItem = localStorage.getItem('hackedu.sandboxes.start')
        const sandboxesStartTime = localStorageItem ? JSON.parse(localStorageItem) : {}
        if (this.browserRef && this.browserRef.props && this.browserRef.props.baseUrl) {
          let sandboxUUID = this.browserRef.props.baseUrl.replace('https://', '').replace('http://', '')
          const indexOfDot = sandboxUUID.indexOf('.')
          sandboxUUID = sandboxUUID.slice(0, indexOfDot)
          if (sandboxesStartTime[sandboxUUID]) {
            const sandboxCreatedAt = moment(sandboxesStartTime[sandboxUUID], 'YYYY-MM-DD HH:mm:ss')
            const lifeTime = (moment.duration(moment().diff(sandboxCreatedAt))).asMinutes()
            if (lifeTime >= 120) {
              // show the modal if the sandbox has been active for more than 2 hours
              try {
                this.inactiveModal.show()
              } catch (e) {
                console.error(e)
              }
            }
          } else {
            sandboxesStartTime[sandboxUUID] = moment().format('YYYY-MM-DD HH:mm:ss')
            localStorage.setItem('hackedu.sandboxes.start', JSON.stringify(sandboxesStartTime))
          }
        }
        if (document.hasFocus()) {
          this.props.pingContent(this.props.match.params.id)
        }
      }, 5000)
    })

    if (this.props.ecsTaskDefinition) {
      this.props.onSandboxReset()
    }

    if (this.props.match.params.id) {
      this.props.getCodeSubmissions(this.props.match.params.id)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.ecsTaskDefinition
      && nextProps.ecsTaskDefinition !== this.props.ecsTaskDefinition
    ) {
      this.props.onSandboxReset()
    }

    if (
      nextProps.ecsTaskDefinition !== ''
      && nextProps.proxyStatus === 'reset'
      && nextProps.proxyStatus !== this.props.proxyStatus
    ) {
      this.props.onSandboxInit()
    } else if (
      nextProps.ecsTaskDefinition !== ''
      && nextProps.proxyStatus === 'init'
      && nextProps.proxyStatus !== this.props.proxyStatus
    ) {
      this.initializeSandbox()
    }

    if (this.props.latestCodeStackTrace !== nextProps.latestCodeStackTrace) {
      if (nextProps.latestCodeStackTrace !== '') {
        this.props.onReplSetOutput(nextProps.latestCodeStackTrace)

        this.props.onReplOnError()
        const b = document.getElementById('proxy-code-output-button')
        b.classList.add('uk-button-danger')
        b.classList.remove('uk-background-secondary')
      }
    }
  }

  componentWillUnmount() {
    this.socket.disconnect()
    if (this.pingInterval) {
      clearInterval(this.pingInterval)
    }
    this.props.resetLinter(true)
    const leftAt = moment()
    if (this.startedAt) {
      analytics.beacon(
        this.startedAt,
        null,
        null,
        leftAt,
        null,
        null,
        this.isDemo ? 'ffaf1a2c-563c-49ea-94f9-a9be559a21b9' : this.props.match.params.id,
        null,
      )
    }
  }

  handleClickProxyTab() {
    this.setState({ editorIsVisible: false })
  }

  handleClickHistoryTab() {
    this.setState({ editorIsVisible: false })
  }

  handleClickCodeTab() {
    this.setState({ editorIsVisible: true })
  }

  handleClickCodeOutputTab() {
    this.setState({ editorIsVisible: false })
  }

  handleClickPatchHistoryTab() {
    this.setState({ editorIsVisible: false })
  }

  handleSandboxReset(clickedByUser) {
    if (this.startedAt !== null) {
      const resetSandboxAt = moment()
      analytics.beacon(
        this.startedAt,
        null,
        null,
        null,
        null,
        resetSandboxAt,
        this.isDemo ? 'ffaf1a2c-563c-49ea-94f9-a9be559a21b9' : this.props.match.params.id,
        null,
      )
    }
    this.setState({
      forceNew: true,
    }, () => {
      this.startedAt = moment()
      this.socket.disconnect()
      this.props.onSandboxReset(clickedByUser)
    })
  }

  cleanSandBoxes(callback) {
    const localStorageItem = localStorage.getItem('hackedu.sandboxes.start')
    const sandboxesStartTime = localStorageItem ? JSON.parse(localStorageItem) : {}
    const cleanedSandboxItem = {}
    Object.keys(sandboxesStartTime).forEach((sandboxUUID) => {
      const sandboxCreatedAt = moment(sandboxesStartTime[sandboxUUID], 'YYYY-MM-DD HH:mm:ss')
      const lifeTime = (moment.duration(moment().diff(sandboxCreatedAt))).asMinutes()
      if (lifeTime < 360) {
        cleanedSandboxItem[sandboxUUID] = sandboxesStartTime[sandboxUUID]
      }
    })
    localStorage.setItem('hackedu.sandboxes.start', JSON.stringify(cleanedSandboxItem))
    if (callback) {
      callback()
    }
  }

  initializeSandbox() {
    if (this.props.authenticationStatus === 'LOGGED_OUT') {
      this.socket = io.connect(settings.urls.control, {
        query: {
          unauthenticatedId: `${this.props.unauthenticatedId}`,
        },
      })
    } else {
      this.socket = io.connect(settings.urls.control, {
        query: {
          token: `${this.props.idToken}`,
        },
      })
    }
    this.socket.on('connect', () => {
      if (!this.state.forceNew) {
        this.startedAt = moment()
      }
      window.onunload = () => {
        const refreshedAt = moment()
        analytics.beacon(
          this.startedAt,
          null,
          refreshedAt,
          null,
          null,
          null,
          this.isDemo ? 'ffaf1a2c-563c-49ea-94f9-a9be559a21b9' : this.props.match.params.id,
          null,
        )
      }
      this.socket.emit('init', {
        ecs_task: this.props.ecsTaskDefinition,
        force_new: this.state.forceNew,
      })
      this.setState({ forceNew: true })
    })

    this.socket.on('init-ack', (msg) => {
      this.handleOnInitAck(msg)
      const receivedAt = moment()
      const arr = msg.host.replace('https://', '').split('.')
      const uuid = arr.shift()
      analytics.beacon(
        this.startedAt,
        receivedAt,
        null,
        null,
        null,
        null,
        this.isDemo ? 'ffaf1a2c-563c-49ea-94f9-a9be559a21b9' : this.props.match.params.id,
        uuid,
      )
      this.startedAt = null
    })

    this.socket.on('init-fail', (msg) => {
      console.error(msg)
      const failedAt = moment()
      analytics.beacon(
        this.startedAt,
        null,
        null,
        null,
        failedAt,
        null,
        this.isDemo ? 'ffaf1a2c-563c-49ea-94f9-a9be559a21b9' : this.props.match.params.id,
        null,
      )
      this.startedAt = null
      this.props.onSetStatus('error')
    })

    this.socket.on('request', (msg) => this.handleOnRequest(cleanObjectRequest(msg)))

    this.socket.on('response', (msg) => this.handleOnResponse(msg))

    this.socket.on('eval-summary', (msg) => {
      if (typeof(msg.output) !== 'undefined' && msg.output !== '') {
        this.props.onReplSetOutput(msg.output)

        if (msg.error === true) {
          this.props.onReplOnError()
          if (this.props.replPatchSubmitted === true && this.props.replErrorViewed === false) {
            const b = document.getElementById('proxy-code-output-button')
            b.classList.add('uk-button-danger')
            b.classList.remove('uk-background-secondary')
          }
        }
      }



      if (this.state.compiling === true) {
        this.setState({ compiling: false })
      }
    })

    this.socket.on('message', (msg) => {
      if (msg.message === 'Intercept set to False') {
        if (this.state.pending_url !== '') {
          this.props.onSetUrl(this.state.pending_url)
          this.setState({ pending_url: '' })
        }
        if (this.props.proxyStatus !== 'init') {
          this.props.onSetStatus('disabled')
        }
      } else if (msg.message === 'Intercept set to True') {
        this.props.onSetStatus('listening')
      }
    })

    this.socket.on('pull-code-response', (msg) => {
      if ('data' in msg) {
        this.props.onReplSetCode(msg.data.data)
        this.props.onReplSetLocalCode(msg.data.data)
        this.props.setReplIsPullingCode(false)
        if (!this.props.firstTimePull) {
          this.props.setFirstTimePull(true)
        }
      }
    })
  }

  handleOnInitAck(msg) {
    this.toggleIntercept(false)
    this.props.onReplSetEngines(msg.engines)
    this.setState({ pending_url: msg.host })
  }

  toggleIntercept(enabled = !this.props.intercept) {
    this.socket.emit('set-intercept', {
      intercept: enabled,
      ecs_task: this.props.ecsTaskDefinition,
    })
    this.props.onSetIntercept(enabled)
  }

  handleOnRequest(request) {
    if (this.props.intercept && !this.state.popoutMode) {
      UIkit.switcher('#tab-proxy').show(0)
      setTimeout(UIkit.offcanvas('#offcanvas-proxy').show, 300)
    }
    this.props.onRequest(request)
  }

  handleOnResume(modified, edited = false) {
    if (edited) {
      this.props.addEditedRequest(modified.request)
    }
    const req = modified.request.split('\n')

    const location = req.shift().split(' ') // ['POST', '/signin', 'HTTP/1.1']
    const method = location[0]
    const path = location[1]
    const httpVersion = location[2]

    if (req.indexOf('') === 0) req.shift() // strip leading empty string
    // everything from last empty string to end is the body
    const body = req.splice(req.indexOf('') + 1, req.length - 1).join('\n')

    const headers = req.reduce((o, i) => {
      i = i.split(': ')
      const key = i[0]
      const val = i[1]
      if (key && val) {
        o[key] = val
      }
      return o
    }, {})

    this.socket.emit('resume', {
      ecs_task: this.props.ecsTaskDefinition,
      method,
      path,
      http_version: httpVersion,
      headers,
      body,
      // TODO: consider encoding body before sending back to proxy
      // body_encoded: window.btoa(window.encodeURI(body)),
    })
  }

  handleOnResponse(msg) {
    const {
      requestCount,
      pendingRequest,
      onResponse,
    } = this.props

    const item = pendingRequest || { body: null }
    item.response = msg

    // Enable intercept if we have 0 or 1 requests (because request 1 is the initial GET on the
    // proxy). But only if intercept_on_load has not been set to false.
    if (requestCount < 2) {
      if (this.props.match.path === '/demo' || this.props.match.path === '/es/demo' || this.props.match.path === '/pt/demo') {
        this.toggleIntercept(true)
      } else if (
        (this.props.match.path === '/challenge/:id') &&
        (
          (!('intercept_on_load' in this.props.contentDetails[this.props.match.params.id])) ||
          (this.props.contentDetails[this.props.match.params.id].intercept_on_load !== false)
        )
      ) {
        this.toggleIntercept(true)
      } else if (
        (this.props.match.params.id in this.props.contentDetails && !('intercept_on_load' in this.props.contentDetails[this.props.match.params.id])) ||
        (this.props.match.params.id in this.props.contentDetails && this.props.contentDetails[this.props.match.params.id].intercept_on_load !== false)
      ) {
        this.toggleIntercept(true)
      }
    }

    if (this.props.intercept && msg.status_code !== 302 && !this.state.popoutMode) {
      UIkit.offcanvas('#offcanvas-proxy').hide()
    }

    onResponse(item)
  }

  handleOnPatch() {
    if (this.props.match.params.id) {
      this.props.getCodeSubmissions(this.props.match.params.id)
      setTimeout(() => {
        this.props.getCodeSubmissions(this.props.match.params.id)
      }, 1000)
      setTimeout(() => {
        this.props.getCodeSubmissions(this.props.match.params.id)
        // if (this.props.match.params.id in this.props.contentDetails && this.props.contentDetails[this.props.match.params.id].app_type === 'native') {
        //   this.setState({ compiling: false })
        // }
      }, 2000)
    }
    if (this.props.match.params.id in this.props.contentDetails && this.props.contentDetails[this.props.match.params.id].app_type === 'native') {
      this.setState({ compiling: true })
    }

    if (!this.state.popoutMode) {
      UIkit.offcanvas('#offcanvas-proxy').hide()
    }
  }

  handleOnPopoutMode(wantsPopoutMode) {
    // If we're already in the desired state, do nothing
    if (this.state.popoutMode === wantsPopoutMode) {
      return
    }

    // If our state is changing, clear any existing timer
    if (this.reapPopoutWindowTimer) {
      clearInterval(this.reapPopoutWindowTimer)
      this.reapPopoutWindowTimer = null
    }

    // Either we don't have a window and we want to open one, or we no longer have/want a window:
    // regardless, *if* there's an existing window that's still open, we want to close it
    if (this.popoutWindow) {
      // If the window is still open, the user has clicked 'Single-Window Mode' so we want to close
      // the window ourselves
      if (!this.popoutWindow.closed) {
        this.popoutWindow.close()
      }
      // Regardless of whether we're closing the window or the user has already done so, record
      // the fact that it's been closed
      analytics.track('event-popout-closed', {
        lessonId: this.props.match.params.id,
        taskId: this.props.ecsTaskDefinition,
        engine: this.props.engine,
      })
    }
    this.popoutWindow = null

    // If we wanted to close the popout window, we're done now; otherwise we know that it's safe
    // to open a new one
    if (wantsPopoutMode) {
      this.toggleIntercept(false)
      this.popoutWindow = window.open(this.props.baseUrl, 'popoutWindow', 'toolbar=1,status=0,width=800,height=1200')

      // Set a periodic timer to check whether our popout window has been closed underneath our
      // nose: if so, we want to update our state to reflect that we're no longer in popout mode
      this.reapPopoutWindowTimer = setInterval(() => {
        // If our popout window was closed or entirely lost to us, disable popout mode
        if (!this.popoutWindow || this.popoutWindow.closed) {
          this.handleOnPopoutMode(false)
        }
      }, 200)
    }

    // Finally, update our state so the UI can adjust itself accordingly
    // NOTE: I don't know why editorIsVisible gets modified all over the place by seemingly
    // unrelated code (and always set to false); it's just old spaghetti so best leave it be
    this.setState({ popoutMode: wantsPopoutMode, editorIsVisible: false })
  }

  rePullCode(engine) {
    engine = engine || this.props.engine
    if (this.socket) {
      if (this.props.engines.includes(engine)) {
        this.socket.emit('pull-code', {
          engine: engine,
        })
      } else if (Array.isArray(this.props.engines) && this.props.engines.length > 0) {
        this.props.onReplSetEngine(this.props.engines[0])
        this.socket.emit('pull-code', {
          engine: this.props.engines[0],
        })
      }
    }
  }
  render() {
    let browserHeight = 'calc(100vh - 90px)'
    if (this.state.popoutMode) {
      browserHeight = 'calc(100vh - 150px)'
    }
    const contentType = (this.props.match.params.id in this.props.contentDetails) ? (
      this.props.contentDetails[this.props.match.params.id].app_type
    ) : (
        null
      )
    let mainWidth = 'calc(67% - 80px)'
    if (this.state.popoutMode) {
      mainWidth = '67%'
    }
    let successfulPatch = false
    for (let i = 0; i < this.props.codeSubmissions.length; i++) {
      if (this.props.codeSubmissions[i].test.passed === true) {
        successfulPatch = true
        break
      }
    }

    let showPassStatus = false
    for (let i = 0; i < this.props.codeSubmissions.length; i++) {
      if (this.props.codeSubmissions[i].test.passed !== null) {
        showPassStatus = true
        break
      }
    }

    let browserTabs = this.props.tabs
    if (this.props.mainTabAppNameOverride) {
      browserTabs = [{ ...this.props.tabs[0], app_name: this.props.mainTabAppNameOverride }].concat(this.props.tabs.slice(1))
    }

    return (
      <div data-test-id="browser-skill-area-component">
        <div
          className="hackedu-sidebar-left uk-background-muted"
          style={{ height: 'calc(100vh - 80px)', width: 'calc(67% - 80px)' }}
          ref={(ref) => { this.lessonStepContainer = ref }}
        >
          <LessonSteps
            lessonStepContainerRef={this.lessonStepContainer}
            onClickBack={(stepIndex) => { this.props.handleClickBack(stepIndex) }}
            onClickCircle={(stepIndex) => { this.props.handleClickCircle(stepIndex) }}
            onClickDone={(stepIndex) => { this.props.handleClickDone(stepIndex) }}
            onClickNext={(stepIndex) => { this.props.handleClickNext(stepIndex) }}
            steps={this.props.steps}
            hints={this.props.hints}
            skillArea
            title={this.props.title}
            description={this.props.description}
            email={this.props.email}
            contentId={this.props.match.params.id}
            lessonCompletionURL={this.props.lessonCompletionURL}
            lessonCompletionText={this.props.lessonCompletionText}
            ecsTaskDefinition={this.props.ecsTaskDefinition}
            currentProgress={this.props.currentProgress}
            hasTest={this.props.hasTest}
            latestCodePassed={this.props.latestCodePassed}
            latestCodePatchId={this.props.latestCodePatchId}
            mustPassCodingExercise={this.props.mustPassCodingExercise}
            contentType={this.props.contentType}
            userId={this.props.userId}
            idToken={this.props.idToken}
            codeSubmissions={this.props.codeSubmissions}
          />
        </div>

        <div className="hackedu-main uk-background-muted" style={{ minHeight: 'calc(100vh - 80px)', width: mainWidth }}>
          <div style={{ height: browserHeight }}>
            <div style={{ background: '#EEEEEE' }}>
              <ProxyBar
                resetCallback={() => {
                  this.browserRef.onTabClick(0)
                }}
                replSetCode={this.props.onReplSetCode}
                intercept={this.props.intercept}
                onToggleIntercept={this.toggleIntercept}
                proxyStatus={this.props.proxyStatus}
                onSandboxReset={this.handleSandboxReset}
                ecsTaskDefinition={this.props.ecsTaskDefinition}
                contentType={contentType}
                handleOnPopout={(mode) => { this.handleOnPopoutMode(mode) }}
                popoutMode={this.state.popoutMode}
                url={this.props.baseUrl}
                tabCount={this.props.tabs.length}
              />
            </div>
            <hr className="uk-margin-remove" />

            <div
              className="uk-margin-remove uk-padding-remove"
              style={{
                height: '100%',
              }}
            >
              {(this.state.popoutMode) ? (
                <div className="uk-section uk-padding-small" style={{ height: browserHeight, paddingBottom: 20 }}>
                  <div className="uk-text-small" style={{ height: 30 }}>
                    Open the sandbox in a new tab:
                    <a href={this.props.baseUrl} target="_blank" rel="noopener noreferrer">
                      <code>{this.props.baseUrl}</code>
                    </a>
                  </div>
                  <div style={{ height: 'calc(100% - 30px)' }}>
                    <div
                      className="uk-background-secondary"
                      style={{
                        border: '2px solid #999999',
                        borderRadius: 4,
                        height: '100%',
                        padding: 1,
                      }}
                    >

                      <div className="uk-background-secondary uk-light uk-padding" style={{ height: 'calc(100% - 80px)' }}>
                        <ul data-uk-tab="active: 0" id="tab-popout">
                          {(contentType !== 'native') && (
                            <li>
                              <a href="#" onClick={this.handleClickProxyTab}>Proxy</a>
                            </li>
                          )}
                          {(contentType !== 'native') && (
                            <li>
                              <a href="#" onClick={this.handleClickHistoryTab}>
                                History
                              <span className="uk-badge uk-margin-small-left uk-padding-remove-vertical uk-padding-small">{this.props.requestCount}</span>
                              </a>
                            </li>
                          )}
                          {(this.props.engines.length > 0) && (
                            <li>
                              <a href="#" onClick={this.handleClickCodeTab}>Code Editor</a>
                            </li>
                          )}
                          {!(this.props.engines.length > 0) && (
                            <li>
                              <a
                                href="#"
                                onClick={this.handleClickCodeOutputTab}
                                style={{
                                  display: 'flex',
                                }}
                              >
                                {!(this.props.output) && (
                                  <Icon className="uk-margin-small-right" name="error-warning" />
                                )}
                                Code Output & Errors
                            </a>
                            </li>
                          )}
                          {(this.props.engines.length > 0) && (
                            <li>
                              <a href="#" onClick={this.handleClickPatchHistoryTab}>
                                {(showPassStatus) && (
                                  <span
                                    className="uk-margin-small-right uk-background-secondary"
                                    style={{
                                      height: 10,
                                      width: 10,
                                      backgroundColor: (successfulPatch) ? ('#32d296') : ('#f0506e'),
                                      borderRadius: '50%',
                                      display: 'inline-block',
                                    }}
                                  />
                                )}
                                Patch History
                              </a>
                            </li>
                          )}
                        </ul>
                        <ul className="uk-switcher uk-margin">
                          {(contentType !== 'native') && (
                            <li>
                              <ProxyEditor
                                pendingRequest={this.props.pendingRequest}
                                handleClickResume={this.handleOnResume}
                                intercept={this.props.intercept}
                              />
                            </li>
                          )}
                          {(contentType !== 'native') && (
                            <li>
                              <ProxyHistory requests={this.props.requests} />
                            </li>
                          )}
                          {(this.props.engines.length > 0) && (
                            <li>
                              <CodeEditor
                                isNative={contentType === 'native'}
                                rePullCode={this.rePullCode.bind(this)}
                                ecsTaskDefinition={this.props.ecsTaskDefinition}
                                editorId="editor-popout"
                                engines={this.props.engines}
                                hasTest={this.props.hasTest}
                                onPatch={this.handleOnPatch}
                                onReplSetEngine={this.props.onReplSetEngine}
                                socket={this.socket}
                                visible={this.state.editorIsVisible}
                                contentUUID={this.props.match.params.id}
                              />
                            </li>
                          )}
                          {(this.props.engines.length > 0) && (
                            <li>
                              <CodeOutput output={this.props.output} />
                            </li>
                          )}
                          {(this.props.engines.length > 0) && (
                            <li>
                              <PatchHistory
                                contentType={contentType}
                                codeSubmissions={this.props.codeSubmissions}
                                hasTest={this.props.hasTest}
                              />
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )
                : (
                  <Browser
                    proxyStatus={this.props.proxyStatus}
                    onRef={(ref) => { this.browserRef = ref }}
                    baseUrl={this.props.baseUrl}
                    tabs={browserTabs}
                    onSandboxSetPath={this.props.onSandboxSetPath}
                    contentType={contentType}
                    compiling={this.state.compiling}
                  />
                )}
            </div>
          </div>
        </div>

        <LessonSidebar
          firstTimePull={this.props.firstTimePull}
          rePullCode={this.rePullCode.bind(this)}
          codeSubmissions={this.props.codeSubmissions}
          compiling={this.state.compiling}
          contentType={contentType}
          ecsTaskDefinition={this.props.ecsTaskDefinition}
          engines={this.props.engines}
          hasTest={this.props.hasTest}
          intercept={this.props.intercept}
          lessons={this.props.lessons}
          onClickResume={this.handleOnResume}
          onPatch={this.handleOnPatch}
          onReplOnViewError={this.props.onReplOnViewError}
          onReplSetEngine={this.props.onReplSetEngine}
          output={this.props.output}
          pendingRequest={this.props.pendingRequest}
          requests={this.props.requests}
          requestCount={this.props.requestCount}
          socket={this.socket}
          patchingTimes={(this.props.contentDetails[this.props.match.params.id] || {}).patching_times || {}}
          showPassStatus={showPassStatus}
          successfulPatch={successfulPatch}
          visible={(!this.state.popoutMode)}
          onReplSetDefaultEngine={this.props.onReplSetDefaultEngine}
        />

        <GenericModal
          noButtons
          ref={(ref) => { this.inactiveModal = ref }}
          id="generic-inactive-modal"
          body={(
            <div className="uk-text-center">
              <Icon
                name="refresh"
                ratio={3}
                className="uk-align-center uk-text-secondary uk-margin-remove-bottom"
              />
              <h3 className="uk-margin-top">
                You have been inactive for more than two hours.
                Please reset the sandbox.
              </h3>
              <button
                className="uk-button uk-button-primary uk-margin-top"
                type="button"
                onClick={() => {
                  this.props.onReplSetCode(null)
                  this.handleSandboxReset(true)
                  this.inactiveModal.hide()
                }}
              >
                Reset Sandbox
              </button>
            </div>
          )}
        />
        <ScratchpadButton id="lesson" />
      </div>
    )
  }
}

BrowserSkillArea.propTypes = propTypes
BrowserSkillArea.defaultProps = defaultProps

const mapStateToProps = state => ({
  // Proxy
  baseUrl: state.proxy.url,
  proxyStatus: state.proxy.status,
  intercept: state.proxy.intercept,
  requests: state.proxy.requests,
  requestCount: Object.keys(state.proxy.requests).length,
  pendingRequest: getPendingRequest(state),

  // Auth
  email: state.auth.user.email,
  unauthenticatedId: state.auth.user.unauthenticatedId,
  authenticationStatus: state.auth.authenticationStatus,
  idToken: state.auth.user.idToken,

  // Content
  contentDetails: state.content.contentDetails,

  // hacker
  codeSubmissions: state.hacker.currentCodeSubmissions,
  latestCodePassed: state.hacker.latestCodePassed,
  latestCodeStackTrace: state.hacker.latestCodeStackTrace,
  latestCodePatchId: state.hacker.latestCodePatchId,
  mustPassCodingExercise: state.hacker.mustPassCodingExercise,

  // Repl
  replPatchSubmitted: state.repl.patchSubmitted,
  replErrorViewed: state.repl.errorViewed,
  engine: state.repl.engine,
  engines: state.repl.engines,
  output: state.repl.output,
  firstTimePull: state.repl.firstTimePull,
})

const mapDispatchToProps = (dispatch) => ({
  // hacker
  getCodeSubmissions: (contentId) => dispatch(getCodeSubmissions(contentId)),

  // Proxy
  onSandboxSetPath: (path, search) => dispatch(sandboxSetPath(path, search)),
  onSetIntercept: (intercept) => dispatch(setIntercept(intercept)),
  onSetStatus: (state) => dispatch(setStatus(state)),
  onSetUrl: (url) => dispatch(setUrl(url)),
  onSandboxInit: (sandboxData) => dispatch(sandboxInit(sandboxData)),
  onSandboxReset: (clickedByUser) => dispatch(sandboxReset(clickedByUser)),
  onRequest: (request) => dispatch(onRequest(request)),
  onResponse: (requests) => dispatch(onResponse(requests)),
  addEditedRequest: (editedRequest) => dispatch(addEditedRequest(editedRequest)),
  // Repl
  onReplSetOutput: (output) => dispatch(replSetOutput(output)),
  onReplOnError: () => dispatch(replOnError()),
  onReplOnViewError: () => dispatch(replOnViewError()),
  onReplSetCode: (code, codeEngine) => dispatch(replSetCode(code, codeEngine)),
  onReplSetLocalCode: (code) => dispatch(replSetLocalCode(code)),
  onReplSetEngines: (engines) => dispatch(replSetEngines(engines)),
  onReplSetEngine: (engine, changed) => dispatch(replSetEngine(engine, changed)),
  onReplSetDefaultEngine: (engine) => dispatch(replSetDefaultEngine(engine)),
  pingContent: (contentUUID) => dispatch(pingContent(contentUUID)),
  resetLinter: (del) => dispatch(resetLinter(del)),
  setReplIsPullingCode: (isPullingNewCode) => dispatch(setReplIsPullingCode(isPullingNewCode)),
  setFirstTimePull: (firstTimePull) => dispatch(setFirstTimePull(firstTimePull)),
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrowserSkillArea))
